<template>
  <div id="app">
    <div v-if="showLoader" class="loader"><span v-html="loader"></span></div>
    <div v-if="!showLoader && url" class="embed-responsive embed-responsive-16by9">
      <iframe class="embed-responsive-item" allow="fullscreen" :src="url"></iframe>
    </div>
  </div>
</template>


<style>

.loader {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 20%;
  left: 45%;
}

svg {
  width: 100px;
  height: 100px;
  margin: 20px;
  display: inline-block;
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden
}

.embed-responsive::before {
  display: block;
  content: ""
}

.embed-responsive .embed-responsive-item, .embed-responsive iframe, .embed-responsive embed, .embed-responsive object, .embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%
}

.embed-responsive-16by9::before {
  padding-top: 56.25%
}

.embed-responsive-4by3::before {
  padding-top: 75%
}

.embed-responsive-1by1::before {
  padding-top: 100%
}
</style>

<script>

import axios from "axios";

export default {
  props: {
    accountId: {
      type: String
    }
  },
  data() {
    return {
      url: null,
      showLoader: true,
    }
  },
  computed: {
    loader() {
      return '<svg version="1.1" id="L3" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"\n' +
          '  viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve">\n' +
          '<circle fill="none" stroke="black" stroke-width="4" cx="50" cy="50" r="44" style="opacity:0.5;"/>\n' +
          '  <circle fill="#fff" stroke="black" stroke-width="3" cx="8" cy="54" r="6" >\n' +
          '    <animateTransform\n' +
          '      attributeName="transform"\n' +
          '      dur="2s"\n' +
          '      type="rotate"\n' +
          '      from="0 50 48"\n' +
          '      to="360 50 52"\n' +
          '      repeatCount="indefinite" />\n' +
          '    \n' +
          '  </circle>\n' +
          '</svg>'
    }
  },
  components: {},
  methods: {
    async getPrimaryUrl() {
      try {
        const {data} = await axios.get(`/account/${this.accountId}/primary-document`)
        if (data && data.data && data.data.url) {
          this.url = `https://pdf-js.web.app?file=${data.data.url}`
        }
      } catch (e) {
        console.error(e)
      }
    }
  },
  async mounted() {
    await this.getPrimaryUrl()
    this.showLoader = false
  }
}

</script>
